import { RATINGS_REVERSED_LIST } from "@goodfill/domain-properties";
import { PricedBond } from "../PricedBond";

export function getBondRatingIndex(bond: Pick<PricedBond, "ratings" | "bondIdCusip">) {
  const moodysIndex = bond.ratings.moodys !== null ? RATINGS_REVERSED_LIST.moodys.indexOf(bond.ratings.moodys) : -1;
  const spIndex = bond.ratings.sp !== null ? RATINGS_REVERSED_LIST.sAndP.indexOf(bond.ratings.sp) : -1;

  return { moodysIndex, spIndex };
}
